import { fechaLocal } from './fecha';

// Eventos del catálogo por día: los del píxel de Meta (meta_pixel_diario) y
// los que cuenta Kontrol (catalogo_eventos_diario, sql/126). Desde el primer
// día que Kontrol cuenta, mandan los de Kontrol; ese primer día se toma el
// mayor de los dos porque Kontrol empezó a contar a mitad del día.
// "Enviaron pedido" (Purchase) de Kontrol sale de los pedidos reales: un
// pedido por bolsa (grupo), así nunca se cuenta uno que no existe.
export function combinarEventos(meta = [], kontrol = [], pedidos = []) {
  const contados = kontrol.filter((e) => e.evento !== 'Purchase');
  const inicio = contados.reduce((m, e) => (!m || e.fecha < m ? e.fecha : m), null);
  const porDia = {};
  if (inicio) {
    for (const p of pedidos) {
      const fecha = fechaLocal(new Date(p.creado_en));
      if (fecha < inicio) continue;
      (porDia[fecha] = porDia[fecha] || new Set()).add(p.grupo || p.id);
    }
  }
  const propios = [...contados, ...Object.entries(porDia).map(([fecha, s]) => ({ fecha, evento: 'Purchase', cantidad: s.size }))];

  const filas = new Map();
  for (const e of meta) filas.set(`${e.fecha}|${e.evento}`, { fecha: e.fecha, evento: e.evento, cantidad: Number(e.cantidad) || 0, origen: 'meta' });
  if (inicio) {
    for (const [k, e] of filas) if (e.fecha > inicio) filas.delete(k);
  }
  for (const e of propios) {
    const k = `${e.fecha}|${e.evento}`;
    const n = Number(e.cantidad) || 0;
    const previo = filas.get(k);
    if (!previo || n >= previo.cantidad) filas.set(k, { fecha: e.fecha, evento: e.evento, cantidad: n, origen: 'kontrol' });
  }
  return { filas: [...filas.values()].sort((a, b) => a.fecha.localeCompare(b.fecha)), inicioKontrol: inicio };
}
